"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.add = add;
exports.all = all;
exports.allAuditList = allAuditList;
exports.allAuditListByServiceCode = allAuditListByServiceCode;
exports.allSelectAuditList = allSelectAuditList;
exports.allSelectOldAuditList = allSelectOldAuditList;
exports.batchCreate = batchCreate;
exports.createOldOrder = createOldOrder;
exports.default = void 0;
exports.del = del;
exports.edit = edit;
exports.editBom = editBom;
exports.getBomByAuditId = getBomByAuditId;
exports.getBomList = getBomList;
exports.getDealerList = getDealerList;
exports.getDistributorCode = getDistributorCode;
exports.getFrameUrl = getFrameUrl;
exports.getServiceCode = getServiceCode;
exports.queryMaterial = queryMaterial;
exports.saveAuDit = saveAuDit;
exports.saveKuJiaLeAuditList = saveKuJiaLeAuditList;
exports.toAuditDelete = toAuditDelete;
exports.toBomDelete = toBomDelete;
exports.updateAuditMesCode = updateAuditMesCode;

var _request = _interopRequireDefault(require("@/utils/request"));

function add(data) {
  return (0, _request.default)({
    url: 'api/cmsCustDesignScheme',
    method: 'post',
    data: data
  });
}

function del(ids) {
  return (0, _request.default)({
    url: 'api/cmsCustDesignScheme/',
    method: 'delete',
    data: ids
  });
}

function edit(data) {
  return (0, _request.default)({
    url: 'api/cmsCustDesignScheme',
    method: 'put',
    data: data
  });
}

function getFrameUrl(designId) {
  return (0, _request.default)({
    url: 'api/cmsCustDesignScheme/getFrameUrl?designId=' + designId,
    method: 'get'
  });
}

function all(custId) {
  return (0, _request.default)({
    url: 'api/cmsCustDesignScheme/all?custId=' + custId,
    method: 'get'
  });
}

function saveKuJiaLeAuditList(data) {
  return (0, _request.default)({
    url: 'api/cmsCustDesignScheme/saveKuJiaLeAuditList?',
    method: 'post',
    data: data
  });
}

function allAuditList(designSchemeId) {
  return (0, _request.default)({
    url: 'api/cmsCustDesignSchemeAudit/all?designSchemeId=' + designSchemeId,
    method: 'get'
  });
}

function allAuditListByServiceCode(serviceCode) {
  return (0, _request.default)({
    url: 'api/cmsCustDesignSchemeAudit/all?mesCode=' + serviceCode,
    method: 'get'
  });
}

function allSelectAuditList(designSchemeId) {
  return (0, _request.default)({
    url: 'api/cmsCustDesignSchemeAudit/all?auditStatus=待审核&designSchemeId=' + designSchemeId + '&queryType={"mesCode":"O"}',
    method: 'get'
  });
} //原单号列表


function allSelectOldAuditList(custId) {
  return (0, _request.default)({
    url: 'api/cmsCustDesignSchemeAudit/getProductionOrderListByCustId?custId=' + custId,
    method: 'get'
  });
}

function saveAuDit(data) {
  return (0, _request.default)({
    url: 'api/cmsCustDesignScheme/saveAuDit?',
    method: 'post',
    data: data
  });
}

function createOldOrder(data) {
  return (0, _request.default)({
    url: 'api/cmsCustDesignSchemeAudit/createOldOrder',
    method: 'post',
    data: data
  });
}

function getBomList(productionOrder) {
  return (0, _request.default)({
    url: 'api/cmsCustDesignScheme/getBomList?productionOrder=' + productionOrder,
    method: 'get'
  });
}

function batchCreate(data) {
  return (0, _request.default)({
    url: 'api/cmsCustBom/batchCreate',
    method: 'post',
    data: data
  });
}

function getBomByAuditId(auditId) {
  return (0, _request.default)({
    url: 'api/cmsCustBom/all?auditId=' + auditId,
    method: 'get'
  });
}

function updateAuditMesCode(data) {
  return (0, _request.default)({
    url: 'api/cmsCustDesignSchemeAudit/syncAudit',
    method: 'put',
    data: data
  });
}

function getDealerList() {
  return (0, _request.default)({
    url: 'api/cmsCustDesignScheme/QueryDealer',
    method: 'get'
  });
}

function getServiceCode(data) {
  return (0, _request.default)({
    url: 'api/cmsCustDesignScheme/getServiceCode?code=' + data,
    method: 'get'
  });
}

function toAuditDelete(ids) {
  return (0, _request.default)({
    url: 'api/cmsCustDesignSchemeAudit/',
    method: 'delete',
    data: ids
  });
}

function toBomDelete(ids) {
  return (0, _request.default)({
    url: 'api/cmsCustBom/',
    method: 'delete',
    data: ids
  });
} // 行内编辑BOM物料


function editBom(data) {
  return (0, _request.default)({
    url: 'api/cmsCustBom',
    method: 'put',
    data: data
  });
}

function getDistributorCode() {
  return (0, _request.default)({
    url: 'api/cmsCustDesignScheme/getDistributorCode',
    method: 'get'
  });
}

function queryMaterial(data) {
  return (0, _request.default)({
    url: 'api/cmsCustDesignScheme/QueryMaterial',
    method: 'post',
    data: data
  });
}

var _default = {
  getDistributorCode: getDistributorCode,
  add: add,
  edit: edit,
  del: del,
  getFrameUrl: getFrameUrl,
  saveKuJiaLeAuditList: saveKuJiaLeAuditList,
  allAuditList: allAuditList,
  all: all,
  allAuditListByServiceCode: allAuditListByServiceCode,
  saveAuDit: saveAuDit,
  allSelectAuditList: allSelectAuditList,
  allSelectOldAuditList: allSelectOldAuditList,
  createOldOrder: createOldOrder,
  getBomList: getBomList,
  batchCreate: batchCreate,
  getBomByAuditId: getBomByAuditId,
  updateAuditMesCode: updateAuditMesCode,
  getDealerList: getDealerList,
  getServiceCode: getServiceCode,
  toAuditDelete: toAuditDelete,
  toBomDelete: toBomDelete,
  queryMaterial: queryMaterial,
  editBom: editBom
};
exports.default = _default;